<template>
    <div>
        <div class="toolbar">
            <fieldset class="toolbar__filters">
                <div class="flex-fix">
                    <input type="hidden" v-model="filters.query" />
                    <FormControlSector
                        name="sectors"
                        v-model="filters.sectors"
                        :multiple="true"
                        :include-ancestors="false"
                    />
                    <FormControlDatepicker
                        name="fromDate"
                        v-model="filters.fromDate"
                        label="From date"
                    />
                    <FormControlDatepicker
                        name="toDate"
                        v-model="filters.toDate"
                        label="To date"
                    />
                </div>
            </fieldset>
        </div>

        <div v-if="$wait.is('loading_search_sector_posts')" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>

        <div
            v-else-if="items && items.length > 0"
            class="sector-post-feed"
        >
            <SectorPostCard
                v-for="item in items"
                :key="`sector-post-${item.id}`"
                :resource="item"
                :load-comments="false"
                :sector-id="item.main_sector"
                :show-read-more="false"
                :show-actions="false"
                @comment-click="handleNavigationToPost(item.main_sector, item.id)"
            />
            <Pagination
                ref="pagination"
                @vuetable-pagination:change-page="onChangePage"
            />
        </div>
        <div v-else class="no-results">No results</div>
    </div>
</template>
<script>
import debounce from 'debounce';
import API from '@api';
import ListFilterOpportunityType from '@components/List/Filter/ListFilterOpportunityType';
import FormControlSector from '@components/Form/Control/FormControlSector';
import FormControlDealType from '@components/Form/Control/FormControlDealType';
import FormControlMember from '@components/Form/Control/FormControlMember';
import ColumnOpportunity from '@components/List/ColumnOpportunity';
import Spinner from '@components/Spinner';

import OpportunitySearchResult from '../Result/Opportunity';
import OpportunityTableHeader from '@components/Search/Headers/Opportunity.vue';
import FormControlDatepicker from '@components/Form/Control/FormControlDatepicker.vue';
import Pagination from '@components/List/Pagination.vue';
import SectorPostCard from '@components/Sector/Post/Card.vue';
import FilterToggle from '@components/Search/FilterToggle.vue';

export default {
    name: 'SearchPageSectorPosts',
    components: {
        FilterToggle,
        SectorPostCard,
        Pagination,
        FormControlDatepicker,
        OpportunityTableHeader,
        Spinner,
        FormControlMember,
        FormControlDealType,
        FormControlSector,
        ListFilterOpportunityType,
        ColumnOpportunity,
        OpportunitySearchResult,
    },
    props: {
        query: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            filters: {
                query: this.query,
                sectors: [],
                fromDate: null,
                toDate: null,
            },
            items: [],
            paginationMeta: {
                page: 1,
            },
        }
    },
    methods: {
        handleChange: () => {},
        async fetchResource() {
            if(this.$wait.is('loading_search_sector_posts'))
                return;

            try {
                this.$wait.start('loading_search_sector_posts');

                const { data, meta } = await API.searchSectorPosts({
                    ...this.filters,
                    page: this.paginationMeta.page,
                });

                this.items = data;
                this.paginationMeta = meta;
            } catch(err) {
                throw new Error(err.message);
            } finally {
                this.$wait.end('loading_search_sector_posts');
            }
        },
        load() {
            this.fetchResource();
        },
        onChangePage(page) {
            this.paginationMeta = {
                ...this.paginationMeta,
                page
            }

            this.fetchResource();
        },
        handleNavigationToPost(sector_id, post_id) {
            this.$router.push({
                name: 'sector-post-view',
                params: { sector_id, post_id },
            })
        },
    },
    watch: {
        'filters': {
            handler: function() {
                this.onChangePage(1);
            },
            deep: true,
        },
        query: {
            handler: function(newQuery) {
                this.filters.query = newQuery;
            },
            deep: true,
        },
        paginationMeta: {
            handler: function() {
                setTimeout(() => { // Timing issue with $refs being inside a v-if
                    if(this.$refs.pagination) {
                        this.$refs.pagination.setPaginationData(this.paginationMeta);
                    }
                })
            },
            deep: true,
        },
    },
    created() {
        this.handleChange = debounce(
            this.fetchResource.bind(this),
            1200,
        );

    },
}
</script>
<style lang="scss" scoped>
.toolbar__filters {
    @media screen and (max-width: 1200px) {
        .flex-fix {
            flex-wrap: wrap;
            gap: 1rem;
            width: 100%;

            .form__group {
                flex: 0 0 calc(33% - .6rem);

                + .form__group {
                    margin-left: 0;
                }
            }
        }
    }

    @media screen and (max-width: 991px) {
        border-bottom: 1px solid #000;
        padding-bottom: 2rem;

        .flex-fix {
            flex-direction: row;

            .form__group {
                width: calc(33% - .6rem);
            }
        }
    }

    @media screen and (max-width: 575px) {
        .flex-fix {
            .form__group {
                flex: 0 0 calc(50% - .6rem);
                width: calc(50% - .6rem);
            }
        }
    }
}
.sector-post-feed {
    padding: 0;
}
</style>
<style lang="scss">
@import "~@/theme/_variables.scss";

.search-results {
    list-style: none;
    padding: 0;
    margin: 0 auto 5rem;

    li + li {
        margin-top: 1.5rem;
        padding-top: 1.5rem;
        border-top: .1rem solid $border;
    }
}

.sector-post-feed {
    max-width: 78rem;
    margin: 0 auto;
}
</style>
